export type PetNameAnimal = 'dog' | 'cat';
export type PetNameGender = 'female' | 'male';

export type DogNameStat = { name: string; rank: number; count: number };

// Sweden's 100 most common dog names in 2025, with national rank and number of dogs.
// Source: Jordbruksverket, "De populäraste hundnamnen 2025". Gender is our own split.
export const dogNameStats: Record<PetNameGender, DogNameStat[]> = {
  female: [
    { name: 'Molly', rank: 1, count: 8636 },
    { name: 'Bella', rank: 2, count: 7786 },
    { name: 'Doris', rank: 4, count: 6129 },
    { name: 'Sally', rank: 5, count: 5703 },
    { name: 'Luna', rank: 7, count: 5460 },
    { name: 'Elsa', rank: 11, count: 4614 },
    { name: 'Stella', rank: 12, count: 4598 },
    { name: 'Selma', rank: 15, count: 3981 },
    { name: 'Alice', rank: 16, count: 3825 },
    { name: 'Freja', rank: 20, count: 3463 },
    { name: 'Wilma', rank: 21, count: 3440 },
    { name: 'Nova', rank: 23, count: 3422 },
    { name: 'Maja', rank: 24, count: 3302 },
    { name: 'Ronja', rank: 26, count: 3290 },
    { name: 'Saga', rank: 28, count: 3073 },
    { name: 'Daisy', rank: 29, count: 3065 },
    { name: 'Zelda', rank: 30, count: 2785 },
    { name: 'Nala', rank: 32, count: 2683 },
    { name: 'Kira', rank: 34, count: 2566 },
    { name: 'Mimmi', rank: 37, count: 2470 },
    { name: 'Leia', rank: 38, count: 2385 },
    { name: 'Svea', rank: 42, count: 2310 },
    { name: 'Smilla', rank: 49, count: 2152 },
    { name: 'Bonnie', rank: 51, count: 2124 },
    { name: 'Siri', rank: 52, count: 2116 },
    { name: 'Nellie', rank: 55, count: 2021 },
    { name: 'Ella', rank: 56, count: 1985 },
    { name: 'Ester', rank: 59, count: 1917 },
    { name: 'Tindra', rank: 61, count: 1913 },
    { name: 'Ebba', rank: 62, count: 1897 },
    { name: 'Stina', rank: 62, count: 1897 },
    { name: 'Lisa', rank: 65, count: 1849 },
    { name: 'Iris', rank: 68, count: 1785 },
    { name: 'Lady', rank: 69, count: 1757 },
    { name: 'Asta', rank: 72, count: 1741 },
    { name: 'Kajsa', rank: 74, count: 1710 },
    { name: 'Mira', rank: 75, count: 1696 },
    { name: 'Lilly', rank: 76, count: 1677 },
    { name: 'Diva', rank: 81, count: 1615 },
    { name: 'Nelly', rank: 82, count: 1600 },
    { name: 'Vera', rank: 86, count: 1482 },
    { name: 'Tyra', rank: 88, count: 1466 },
    { name: 'Astrid', rank: 89, count: 1465 },
    { name: 'Dixie', rank: 91, count: 1461 },
    { name: 'Isa', rank: 93, count: 1390 },
    { name: 'Vilda', rank: 95, count: 1357 },
    { name: 'Maya', rank: 97, count: 1328 },
    { name: 'Lovis', rank: 98, count: 1324 },
    { name: 'Greta', rank: 98, count: 1324 },
    { name: 'Polly', rank: 100, count: 1314 },
  ],
  male: [
    { name: 'Charlie', rank: 3, count: 6309 },
    { name: 'Bosse', rank: 6, count: 5514 },
    { name: 'Sigge', rank: 8, count: 5275 },
    { name: 'Milo', rank: 9, count: 4839 },
    { name: 'Ludde', rank: 10, count: 4693 },
    { name: 'Harry', rank: 13, count: 4057 },
    { name: 'Bamse', rank: 14, count: 4015 },
    { name: 'Ozzy', rank: 17, count: 3540 },
    { name: 'Leo', rank: 18, count: 3493 },
    { name: 'Max', rank: 19, count: 3471 },
    { name: 'Rocky', rank: 22, count: 3429 },
    { name: 'Enzo', rank: 25, count: 3291 },
    { name: 'Hugo', rank: 27, count: 3125 },
    { name: 'Atlas', rank: 31, count: 2774 },
    { name: 'Zorro', rank: 33, count: 2579 },
    { name: 'Elvis', rank: 35, count: 2530 },
    { name: 'Loke', rank: 36, count: 2507 },
    { name: 'Frasse', rank: 39, count: 2358 },
    { name: 'Malte', rank: 40, count: 2354 },
    { name: 'Bruno', rank: 41, count: 2339 },
    { name: 'Teddy', rank: 43, count: 2268 },
    { name: 'Simba', rank: 44, count: 2257 },
    { name: 'Dino', rank: 45, count: 2197 },
    { name: 'Jack', rank: 46, count: 2180 },
    { name: 'Tyson', rank: 47, count: 2179 },
    { name: 'Buster', rank: 48, count: 2163 },
    { name: 'Morris', rank: 50, count: 2140 },
    { name: 'Gizmo', rank: 53, count: 2114 },
    { name: 'Sixten', rank: 54, count: 2029 },
    { name: 'Alfons', rank: 57, count: 1981 },
    { name: 'Baloo', rank: 58, count: 1937 },
    { name: 'Rex', rank: 60, count: 1916 },
    { name: 'Nisse', rank: 64, count: 1896 },
    { name: 'Boss', rank: 66, count: 1813 },
    { name: 'Molle', rank: 67, count: 1808 },
    { name: 'Nemo', rank: 70, count: 1755 },
    { name: 'Diesel', rank: 71, count: 1742 },
    { name: 'Milou', rank: 73, count: 1726 },
    { name: 'Svante', rank: 77, count: 1673 },
    { name: 'Milton', rank: 78, count: 1664 },
    { name: 'Otto', rank: 79, count: 1661 },
    { name: 'Zigge', rank: 80, count: 1629 },
    { name: 'Dexter', rank: 83, count: 1586 },
    { name: 'Eddie', rank: 84, count: 1549 },
    { name: 'Rambo', rank: 85, count: 1484 },
    { name: 'Texas', rank: 87, count: 1475 },
    { name: 'Sune', rank: 89, count: 1465 },
    { name: 'Nalle', rank: 92, count: 1456 },
    { name: 'Pepsi', rank: 94, count: 1374 },
    { name: 'Viggo', rank: 96, count: 1344 },
  ],
};

// Dog names come from the register above; cat names are popular Nordic names (no public register).
export const petNames: Record<PetNameAnimal, Record<PetNameGender, string[]>> = {
  dog: {
    female: dogNameStats.female.map((stat) => stat.name),
    male: dogNameStats.male.map((stat) => stat.name),
  },
  cat: {
    female: [
      'Luna',
      'Nala',
      'Misse',
      'Mysan',
      'Tussan',
      'Majken',
      'Mimmi',
      'Doris',
      'Kisse',
      'Smilla',
      'Molly',
      'Bella',
      'Cleo',
      'Lola',
      'Saga',
      'Freja',
      'Gullan',
      'Hilda',
      'Lisa',
      'Maja',
      'Nora',
      'Pixie',
      'Pyret',
      'Sessan',
      'Sigrid',
      'Stella',
      'Tindra',
      'Trassel',
      'Ylva',
      'Zelda',
      'Alma',
      'Bianca',
      'Daisy',
      'Elsa',
      'Frida',
      'Greta',
      'Ida',
      'Juni',
      'Lussan',
      'Minou',
      'Nova',
      'Olivia',
      'Polly',
      'Ronja',
      'Selma',
      'Siri',
      'Tilda',
      'Vanja',
      'Winnie',
      'Ebba',
      'Fia',
      'Honey',
      'Kiki',
      'Lykke',
      'Mira',
      'Mocca',
      'Pärla',
      'Smulan',
      'Tess',
      'Viola',
    ],
    male: [
      'Simba',
      'Findus',
      'Morris',
      'Gustav',
      'Elvis',
      'Sixten',
      'Leo',
      'Milo',
      'Oliver',
      'Charlie',
      'Frasse',
      'Garfield',
      'Mio',
      'Nisse',
      'Pelle',
      'Sigge',
      'Tiger',
      'Totte',
      'Viggo',
      'Zorro',
      'Albin',
      'Bamse',
      'Bosse',
      'Caspar',
      'Felix',
      'Gizmo',
      'Harry',
      'Ivar',
      'Jasper',
      'Kalle',
      'Loke',
      'Ludde',
      'Måns',
      'Nemo',
      'Oskar',
      'Pluto',
      'Ragnar',
      'Tusse',
      'Uno',
      'Valle',
      'Wilson',
      'Arne',
      'Basse',
      'Elton',
      'Figaro',
      'Gösta',
      'Hugo',
      'Lillen',
      'Murre',
      'Nils',
      'Otto',
      'Rufus',
      'Silvester',
      'Tom',
      'Ville',
      'Sotis',
      'Kasper',
      'Bertil',
      'Pontus',
      'Svante',
    ],
  },
};
